import React from 'react';
import NavBar from '../components/NavBar/navBar.component'
import Contact from '../components/Contact/contact.component'
import Footer from '../components/Footer/footer.component'
import VCardComponent from '../components/VCard/VCard.component';

function VCard() {
  return (
    <> 
      <NavBar/>
      <VCardComponent/>
      <Footer/>
    </>
  )
}

export default VCard